import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import {
  footerApiResponseSuccess,
  footerApiResponseError,
  getfooter,
} from "./actions";

// constants
import { FooterActionTypes } from "./constants";
import {
  addfooterApi,
  deletefooterApi,
  getfooterApi,
  updatefooterApi,
} from "../../helpers/api/footer";

interface footerData {
  payload: {
    id: string;
    footer_en: string;
    footer_ar: string;
  };
  type: string;
}

function* createfooter({
  payload: { footer_en, footer_ar },
  type,
}: footerData): SagaIterator {
  try {
    const response = yield call(addfooterApi, {
      footer_en,
      footer_ar,
    });
    

    const footerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      footerApiResponseSuccess(FooterActionTypes.CREATE_FOOTER, footerData)
    );
    yield put(getfooter());
  } catch (error: any) {
    yield put(footerApiResponseError(FooterActionTypes.CREATE_FOOTER, error));
  }
}

function* updatefooter({
  payload: { id, footer_en, footer_ar },
}: footerData): SagaIterator {
  try {
    const response = yield call(updatefooterApi, id, {
      footer_en,
      footer_ar,
    });
    const footerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      footerApiResponseSuccess(FooterActionTypes.UPDATE_FOOTER, footerData)
    );
    yield put(getfooter());
  } catch (error: any) {
    yield put(footerApiResponseError(FooterActionTypes.UPDATE_FOOTER, error));
  }
}

function* getFooters(): SagaIterator {
  try {
    const response = yield call(getfooterApi);
    const footerData = response?.data?.data;

    yield put(
      footerApiResponseSuccess(FooterActionTypes.GET_FOOTER, footerData)
    );
  } catch (error: any) {
    yield put(footerApiResponseError(FooterActionTypes.GET_FOOTER, error));
  }
}

function* deletefooter({ payload: { id } }: footerData): SagaIterator {
  try {
    const response = yield call(deletefooterApi, id);
    const footerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      footerApiResponseSuccess(FooterActionTypes.DELETE_FOOTER, footerData)
    );
    yield put(getfooter());
  } catch (error: any) {
    yield put(footerApiResponseError(FooterActionTypes.DELETE_FOOTER, error));
  }
}

export function* watchCreatefooter() {
  yield takeEvery(FooterActionTypes.CREATE_FOOTER, createfooter);
}
export function* watchUpdatefooter() {
  yield takeEvery(FooterActionTypes.UPDATE_FOOTER, updatefooter);
}
export function* watchGetfooter() {
  yield takeEvery(FooterActionTypes.GET_FOOTER, getFooters);
}

export function* watchDeletefooter() {
  yield takeEvery(FooterActionTypes.DELETE_FOOTER, deletefooter);
}

function* footerSaga() {
  yield all([
    fork(watchCreatefooter),
    fork(watchUpdatefooter),
    fork(watchDeletefooter),
    fork(watchGetfooter),
  ]);
}

export default footerSaga;
